import React from 'react';

const MessageBox = () => {
  const messages = [
    { id: 1, name: 'Abhishek Gujjar', date: 'Apr 25', content: 'Careers: My name is Abhishek Gujjar and I\'m currently seeking jo...' },
    { id: 2, name: 'Manish Jangir', date: 'Apr 15', content: 'Careers: Dear HR, I am excited to apply for the Web...' },
    { id: 3, name: 'Aigar Arandi', date: 'Mar 3', content: 'Aigar: Hi, we will like to help your company in a crucial growth stage...' },
    { id: 4, name: 'Karan Singh Shekhawat', date: 'Feb 25', content: 'Karan: want join logicpiece as a video editor' },
    { id: 4, name: 'Karan Singh Shekhawat', date: 'Feb 25', content: 'Karan: want join logicpiece as a video editor' },

    { id: 4, name: 'Karan Singh Shekhawat', date: 'Feb 25', content: 'Karan: want join logicpiece as a video editor' },

  ];

  return (
    <div className="w-2/4 bg-white border-r border-gray-200 rounded p-1 overflow-y-auto h-[500px]">
      <div className="mt-4 space-y-2">
        {messages.map((msg) => (
          <div key={msg.id} className="flex items-center p-2 hover:bg-gray-100 rounded">
            <div className>
            <img
              src={`https://i.pravatar.cc/40?img=${msg.id}`} // Placeholder avatar
              alt={msg.name}
              className="w-14 h-14 rounded-full mr-2"
            />
            </div>
            <div className="block w-full px-2">

            
            
            <div className="flex items-center justify-between w-full">
              <div className="font-semibold text-lg">{msg.name}</div>
              <div className="text-sm text-gray-500">{msg.date}</div>
            </div>
            <p className="text-md font-semibold text-gray-900">Careers</p>
            <div className="text-sm overflow-hidden text-ellipsis">{msg.content}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MessageBox;